// @flow

"use strict";

/**
 * WidgetのStyle系情報を保持
 */
export default class OuterWidgetAttribute {
  constructor(height: number, mediaZoom: number) {
    this.height = height;
    this.mediaZoom = mediaZoom;
  }

  /**
   * create
   * @param window
   * @param doc
   * @param iframeParentDiv
   * @returns {OuterWidgetAttribute}
   */
  static create(window: Window, doc: HTMLDocument, iframeParentDiv: HTMLDivElement): OuterWidgetAttribute {
    let heightPx;
    let height;
    try {
      if (!window.getComputedStyle) {
        heightPx = iframeParentDiv.currentStyle['height'];
      } else {
        heightPx = window.getComputedStyle(iframeParentDiv).getPropertyValue('height');
      }
      height = parseInt(heightPx.replace(/px/, ""));
    } catch (e) {
      height = 0;
    }

    const mediaZoom = function(doc: HTMLDocument): number {
      try {
        return +doc.getElementsByTagName('html')[0].style.zoom || 1;
      } catch (e) {
        return 1;
      }
    }(doc);


    return new OuterWidgetAttribute(height, mediaZoom);
  }
}


// WEBPACK FOOTER //
// ./src/js/model/outer/outer-widget-attribute.js